var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "brave",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.906,
    height: 48,
    viewBox: "0 0 40.906 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-brave",
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#fff",
    stopOpacity: 0.957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.698
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-brave-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0d2d3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65044",
    "data-name": "Path 65044",
    d: "M40.905,15.515,39.419,11.5l1.023-2.3a.811.811,0,0,0-.16-.879L37.486,5.5a4.53,4.53,0,0,0-4.7-1.087l-.783.272L27.723.048,20.485,0h-.048L13.15.064,8.884,4.73l-.767-.272a4.488,4.488,0,0,0-4.73,1.1L.543,8.437a.644.644,0,0,0-.144.7l1.071,2.4L0,15.547l.959,3.627L5.3,35.68a8.38,8.38,0,0,0,3.26,4.714s5.273,3.723,10.466,7.095A2.674,2.674,0,0,0,20.485,48a2.674,2.674,0,0,0,1.454-.511C27.787,43.654,32.4,40.378,32.4,40.378a8.431,8.431,0,0,0,3.244-4.714l4.314-16.506Z",
    fill: "#f15a22"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65045",
    "data-name": "Path 65045",
    d: "M5.513,64.683,0,44.2l1.614-4.011L.5,37.216,3.164,34.5a3.492,3.492,0,0,1,3.4-.591l4.17,2.4,5.433,1.262L20.4,35.81l.352,36.383c-.064,5.241.272,4.682-3.579,2.205L7.67,68.023A7.451,7.451,0,0,1,5.513,64.683Z",
    transform: "translate(0 -28.3)",
    opacity: 0.15,
    fill: "url(#linear-gradient-brave)",
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65046",
    "data-name": "Path 65046",
    d: "M140.276,63.977l-8.085,5.529c-2.253,1.23-3.34,2.445-3.515,1.854a35.962,35.962,0,0,1-.08-3.931l-.1-35.585c.016-.352.256-.943.671-.879l4.122,1.246,5.944-.927,3.931-2.892a1.09,1.09,0,0,1,1.406.08l3.515,3.356a1.385,1.385,0,0,1,.144,1.406l-.975,1.806,1.614,4.17-5.561,20.676A7.749,7.749,0,0,1,140.276,63.977Z",
    transform: "translate(-107.967 -23.671)",
    opacity: 0.4,
    fill: "url(#linear-gradient-brave-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65047",
    "data-name": "Path 65047",
    d: "M94.538,184.045a1.947,1.947,0,0,0-.463-.144h-.511a1.947,1.947,0,0,0-.463.144l-2.077.863c-.192.08-.511.224-.7.32l-3.132,1.63a.214.214,0,0,0-.032.4l2.764,1.949c.176.128.447.336.607.479l1.23,1.055c.16.144.415.368.575.511l1.182,1.055a.437.437,0,0,0,.575,0l1.214-1.055c.16-.144.415-.368.575-.511l1.23-1.071c.16-.144.431-.352.607-.479l2.764-1.965a.214.214,0,0,0-.032-.4l-3.132-1.6c-.192-.1-.511-.24-.7-.32Z",
    transform: "translate(-73.127 -154.516)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65048",
    "data-name": "Path 65048",
    d: "M61.429,53.658a1.168,1.168,0,0,0,.064-.288,6.179,6.179,0,0,0-.048-.767l-.16-.463a5.589,5.589,0,0,0-.383-.671L59.1,48.8c-.112-.176-.32-.447-.463-.623L56.3,45.254c-.128-.16-.256-.3-.272-.288H56s-.176.032-.383.064l-3.563.7c-.208.048-.543.112-.751.144l-.064.016a1.991,1.991,0,0,1-.751-.048L47.5,44.886c-.208-.064-.543-.16-.735-.208a5.03,5.03,0,0,0-1.1-.128,6.416,6.416,0,0,0-1.1.128c-.208.048-.543.144-.735.208l-2.988.959a1.991,1.991,0,0,1-.751.048l-.064-.016c-.208-.032-.543-.112-.751-.144l-3.6-.671A3.193,3.193,0,0,0,35.288,45h-.032a1.6,1.6,0,0,0-.272.288L32.651,48.21c-.128.16-.336.447-.463.623L30.382,51.5c-.112.176-.288.479-.383.671l-.16.463a4.123,4.123,0,0,0-.048.767,1.363,1.363,0,0,0,.064.288,2.58,2.58,0,0,0,.383.735c.128.16.368.431.511.575l5.289,5.625a.664.664,0,0,1,.112.639l-1.1,2.6a1.107,1.107,0,0,0-.016.719l.3.815A4.075,4.075,0,0,0,36.6,67.16l1.071.863a.654.654,0,0,0,.639.08L41.7,66.489a3.451,3.451,0,0,0,.639-.431l2.429-2.189a.859.859,0,0,0,.048-1.214l-5.1-3.435a.446.446,0,0,1-.144-.559l2.237-4.218a.931.931,0,0,0,.032-.687l-.272-.623a1.1,1.1,0,0,0-.511-.5l-6.567-2.461c-.192-.08-.192-.16.016-.176l4.234-.4a2.985,2.985,0,0,1,.751.064l3.771,1.055a.436.436,0,0,1,.3.479l-1.31,7.174a1.777,1.777,0,0,0,.016.655.639.639,0,0,0,.463.352l2.621.559a1.979,1.979,0,0,0,.751,0l2.445-.559a.68.68,0,0,0,.463-.352,1.481,1.481,0,0,0,.016-.655L47.735,51.2a.427.427,0,0,1,.3-.479l3.771-1.055a2.394,2.394,0,0,1,.751-.064l4.234.4c.208.016.224.1.016.176l-6.567,2.493a1.028,1.028,0,0,0-.511.5l-.272.623a.856.856,0,0,0,.032.687l2.253,4.218a.451.451,0,0,1-.144.559L46.5,62.7a.845.845,0,0,0,.048,1.214l2.429,2.189a2.741,2.741,0,0,0,.639.415l3.4,1.614a.654.654,0,0,0,.639-.08l1.071-.879a3.915,3.915,0,0,0,1.246-1.758l.3-.815a1.109,1.109,0,0,0-.016-.719l-1.1-2.6a.664.664,0,0,1,.112-.639l5.289-5.625c.144-.16.368-.415.511-.575C61.045,54.393,61.333,54.042,61.429,53.658Z",
    transform: "translate(-25.027 -37.431)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrave);
export default __webpack_public_path__ + "static/media/brave.b57a651db94979fae8802bbfb32b87e3.svg";
export { ForwardRef as ReactComponent };